import type { Percentage, Point } from "@pdfking/math"
import type { FileName } from "@pdfking/structs"

import type { ColorID, LayerID } from "#public"

export const NO_SCALE = { x: 1, y: 1 } as Point<Percentage>
export const NO_COLOR = "" as ColorID
export const NO_LAYER = "" as LayerID
export const NO_FILE = "" as FileName
